document.addEventListener('DOMContentLoaded', (event) => {
    const iframe = document.getElementById('myIframe');
    const iframeContainer = document.querySelector('.iframe-container');

    let isScrollingDisabled = false;

    function preventScroll(e) {
        if (isScrollingDisabled) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    function disableScroll() {
        isScrollingDisabled = true;
        document.body.style.overflow = 'hidden';
    }

    function enableScroll() {
        isScrollingDisabled = false;
        document.body.style.overflow = '';
    }

    iframe.addEventListener('mouseenter', () => {
        disableScroll();
    });

    iframe.addEventListener('mouseleave', () => {
        enableScroll();
    });

    window.addEventListener('wheel', preventScroll, { passive: false });
    window.addEventListener('touchmove', preventScroll, { passive: false });
});
